import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import removeHtmlTags from '../../helpers/removeHtmlTags';

function OurMissionCircle({ styles }) {
  return (
    <div style={{ ...styles }} />
  );
}
function OurMission({
  ourMissionTitle, ourMissionDescription, ourVisionTitle, ourVisionDescription,
}) {
  const { width } = useWindowSize();
  return (
    <div className="our__mission">
      <div className="container medium">
        <div className="our__mission-content">
          <div className="our__mission-card">
            <OurMissionCircle
              styles={{
                width: width < 768 ? '288px' : '377px',
                height: width < 768 ? '288px' : '377px',
                position: 'absolute',
                left: width < 768 ? '232px' : '-197px',
                top: width < 768 ? '-160px' : '-277px',
                borderRadius: '377px',
                border: '80px solid #005AA8',
                opacity: '0.06',
              }}
            />
            <h3>{removeHtmlTags(ourMissionTitle)}</h3>
            <p>
              {removeHtmlTags(ourMissionDescription)}
            </p>
          </div>
          <div className="our__mission-card">
            <OurMissionCircle styles={{
              width: width < 768 ? '288px' : '377px',
              height: width < 768 ? '288px' : '377px',
              position: 'absolute',
              right: width < 768 ? '-53px' : '-188px',
              bottom: width < 768 ? '-170px' : '-285px',
              borderRadius: '377px',
              border: '80px solid #005AA8',
              opacity: '0.06',
            }}
            />
            <h3>{removeHtmlTags(ourVisionTitle)}</h3>
            <p>
              {removeHtmlTags(ourVisionDescription)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurMission;
